import React from "react";
import { Link } from "../../components/LinkIcon";
import { useTranslation } from "react-i18next";
import "./index.less";

const SSOPageContent = ({ title, subTitle, docsText, docsLink } = {}) => {
  const { t } = useTranslation();
  const address = "learn.ssoPage.";
  return (
    <div className="ssoPage_container">
      <div className="ssoPage_children_one">
        <div className="ssoPage_box">
          <img
            src={t("learn.ssoPage.box_one.img")}
            // src="//files.authing.co/authing-website/sso-access-img-v2.png"
            alt="支持多种协议的单点登录"
          />
        </div>
        <div className="ssoPage_box">
          <div className="ssoPage_subBox">
            <div className="title">{t(address + "box_one.title")}</div>
            <br />
            <div className="content">
              {t(address + "box_one.content_one")}
              <br /> <br />
              {t(address + "box_one.content_two")}
            </div>
          </div>
        </div>
      </div>
      <div className="ssoPage_children_two">
        <div className="title"> {title || t(address + "box_two.title")}</div>
        <br />
        <div className="content">
          {subTitle || t(address + "box_two.content")}
        </div>
      </div>
      <div className="ssoPage_children_three">
        <div className="box_left">
          <img
            src="//files.authing.co/authing-website/sso-apn-img-new-bg-1.png"
            alt="单点登录软件"
          />
          <div className="box">
            <div className="title"> {t(address + "box_two.left.title")}</div>
            <div className="content">{t(address + "box_two.left.content")}</div>

            <Link href="/apn">{t(address + "box_two.left.link")}</Link>
          </div>
        </div>
        <div className="box_right">
          <div className="subBox_top">
            <div className="subBox_top_children">
              <div className="box">
                <img
                  src="//files.authing.co/authing-website/sso-icon-console.png"
                  alt="authing"
                />
                <div className="title">
                  {t(address + "box_two.right_one.title")}
                </div>
                <div className="content">
                  {t(address + "box_two.right_one.content")}
                </div>
                <Link
                  href={docsLink || "https://console.authing.cn/"}
                  target="_blank"
                >
                  {docsText || t(address + "box_two.right_one.link")}
                </Link>
              </div>
            </div>
            <div className="subBox_top_children">
              <div className="box">
                <img
                  src="//files.authing.co/authing-website/sso-icon-storage.png"
                  alt="authing"
                />
                <div className="title">
                  {t(address + "box_two.right_two.title")}
                </div>
                <div className="content">
                  {t(address + "box_two.right_two.content")}
                </div>
                <Link
                  href="https://docs.authing.cn/v2/reference/sdk-for-sso.html"
                  target="_blank"
                >
                  {docsText || t(address + "box_two.right_two.link")}
                </Link>
              </div>
            </div>
          </div>
          <div className="subBox_bottom">
            <div className="box">
              <div className="subBox_bottom_left">
                <div className="title">
                  {t(address + "box_two.right_three.title")}
                </div>
                <div className="content">
                  {t(address + "box_two.right_three.content")}
                </div>
                <Link
                  href="https://docs.authing.cn/v2/guides/access-control/"
                  target="_blank"
                >
                  {docsText || t(address + "box_two.right_three.link")}
                </Link>
              </div>
              <div className="subBox_bottom_right">
                <img
                  src="//files.authing.co/authing-website/sso-security-img.png"
                  alt="单点登录实现方案"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { SSOPageContent };
